import {_urlAreas, _urlBuildings, _urlFloors, _urlParking, _urlReservation, request} from "../api";
import {BUILDINGS_CONSTS, UTIL_CONSTS} from "../constants";

export const GetAreasInitialInfo = () => {
    const requestData = {
        url: `${_urlAreas}/info`,
        method: "GET",
        token: true,
        languageFlag: true,
    };

    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                data && dispatch({
                    type: BUILDINGS_CONSTS.GET_AREAS_INITIAL_INFO,
                    payload: data
                })
            })
    };
};

export const GetAreasInfo = ({
                                 type = null,
                                 roomsCount = [],
                                 minPrice = '',
                                 maxPrice = '',
                                 MIN_PRICE,
                                 MAX_PRICE
                             } = {}) => {
    console.log('types', type)
    console.log('roomsCount', roomsCount)
    console.log('maxPrice', maxPrice)
    console.log('minPrice', minPrice)
    console.log('MIN_PRICEMAX_PRICE', MIN_PRICE, MAX_PRICE)
    const requestData = {
        url: `${_urlAreas}/info?offset=0`,
        method: "GET",
        languageFlag: true
    };


    type && (requestData.url += `&types=${type}`);
    roomsCount?.length && (requestData.url += `&roomsCount=${roomsCount?.join(",")}`);
    minPrice && (minPrice !== MIN_PRICE) && (requestData.url += `&minPrice=${minPrice}`);
    maxPrice && maxPrice < MAX_PRICE && (requestData.url += `&maxPrice=${maxPrice}`);

    return dispatch => {
        return request(requestData)
            .then(async (res) => {
                const data = res && res.data;
                await dispatch({
                    type: BUILDINGS_CONSTS.GET_AREAS_INFO,
                    payload: data
                })
            })
    };
};


export const ResetAreasInfo = () => {
    return dispatch => {
        dispatch({
            type: BUILDINGS_CONSTS.RESET_AREAS_INFO,
        })
    }
}


export const GetBuildings = () => {
    const requestData = {
        url: `${_urlBuildings}`,
        method: "GET",
        languageFlag: true
    };

    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                dispatch({
                    type: BUILDINGS_CONSTS.GET_BUILDINGS,
                    payload: data
                })
                return data
            })
    };
};

export const GetBuildingByIdOrSlug = (id) => {
    const requestData = {
        url: `${_urlBuildings}/${id}`,
        method: "GET",
        languageFlag: true,
        token: true
    };
    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                dispatch({
                    type: BUILDINGS_CONSTS.GET_BUILDING_BY_ID,
                    payload: data
                })
                return data
            })
    };
};

export const GetFloorById = (id) => {
    const requestData = {
        url: `${_urlFloors}/${id}`,
        method: "GET",
        languageFlag: true,
        token: true
    };
    return () => {
        return request(requestData)
            .then((res) => {
                return res && res.data
            })
    };
};

export const GetHouseById = (id) => {
    const requestData = {
        url: `${_urlAreas}/${id}`,
        method: "GET",
        languageFlag: true,
        token: true
    };
    return () => {
        return request(requestData)
            .then((res) => {
                return res && res.data
            })
    };
};

export const GetParkingById = (id) => {
    const requestData = {
        url: `${_urlParking}/${id}`,
        method: "GET",
        languageFlag: true,
        token: true
    };
    return () => {
        return request(requestData)
            .then((res) => {
                return res && res.data
            })
    };
};

export const ReserveHouse = (data) => {
    const requestData = {
        url: `${_urlReservation}`,
        method: "POST",
        data
    };
    return dispatch => {
        dispatch({type: UTIL_CONSTS.START_LOADING});
        return request(requestData).finally(() => {
            dispatch({type: UTIL_CONSTS.END_LOADING})
        })
    }
};

export const FilterState = to => {
    return {
        type: BUILDINGS_CONSTS.STATE_FILTER,
        payload: to,
    }
}

export const GetAreaBestOffers = () => {
    const requestData = {
        url: `${_urlAreas}/best-offers`,
        method: "GET",
        languageFlag: true,
        token: true
    };
    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                dispatch({
                    type: BUILDINGS_CONSTS.GET_AREAS_BEST_OFFER,
                    payload: data
                })
                return data
            })
    };
};

export const GetAreasMinPrices = () => {
    const requestData = {
        url: `${_urlAreas}/min-prices`,
        method: "GET",
        languageFlag: true,
        token: true
    };
    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                dispatch({
                    type: BUILDINGS_CONSTS.GET_AREAS_MIN_PRICES,
                    payload: data
                })
                return data
            })
    };
};

export const GetAreas = ({
                              offset = 0,
                              limit = 20,
                              reset = true,
                              buildingSlug = null,
                              type = null,
                              floors = undefined,
                              roomsCount = [],
                              minArea = '',
                              maxArea = '',
                              minPrice = '',
                              maxPrice = '',
                              statuses = [],
                              sort = '',
                             MIN_PRICE,
                             MAX_PRICE,
                             MIN_AREA,
                             MAX_AREA
                          } = {}) => {
    const requestData = {
        url: `${_urlAreas}?offset=${offset}&limit=${limit}`,
        method: "GET",
        token: true,
        languageFlag: true,
    };
    buildingSlug && (requestData.url += `&buildingSlug=${buildingSlug}`);
    roomsCount && roomsCount.length && (requestData.url += `&roomsCount=${roomsCount.join(',')}`);
    type && (requestData.url += `&types=${type}`);
    floors && (requestData.url += `&floors=${floors}`);

    minPrice && (minPrice !== MIN_PRICE) && (requestData.url += `&minPrice=${minPrice}`);
    maxPrice && maxPrice < MAX_PRICE && (requestData.url += `&maxPrice=${maxPrice}`);
    minArea && (minArea !== MIN_AREA) && (requestData.url += `&minArea=${minArea}`);
    maxArea && maxArea < MAX_AREA && (requestData.url += `&maxArea=${maxArea}`);

    sort && (requestData.url += `&sort=${sort}`);
    statuses?.length && (requestData.url += `&statuses=${statuses?.join(",")}`);

    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                data && dispatch({
                    type: BUILDINGS_CONSTS.GET_AREAS,
                    payload: {
                        data: data?.areas,
                        hasMore: data?.areas?.length === limit,
                        count: data?.count,
                        availableCount: data?.availableCount,
                        reservedCount: data?.reservedCount,
                        reset,
                        // buildingSlug,
                        // floors,
                        // roomsCount,
                        // minArea,
                        // maxArea,
                        // minPrice,
                        // maxPrice,
                        // sort,
                        // statuses,
                    }
                })
            })
    };
};




export const RemoveAreasList = () => {
    return dispatch => {
        dispatch({
            type: BUILDINGS_CONSTS.REMOVE_AREAS_LIST,
        })
    }
}
